// Tabs
class TabsCustom extends HTMLElement {
  static activeClass = "is-active";

  get bodies() {
    const groupId = this.dataset.groupId;
    const bodies = document.querySelectorAll(
      `.js-tabs-body-item[data-group-id="${groupId}"]`
    );

    if (bodies.length === 0) throw new Error("Tab bodies elements not found");

    return bodies;
  }

  get navItems() {
    const groupId = this.dataset.groupId;
    const navItems = document.querySelectorAll(
      `.js-tabs-nav-item[data-group-id="${groupId}"]`
    );

    if (navItems.length === 0)
      throw new Error("Tab Nav Items elements not found");

    return navItems;
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.addEventListener("click", this.handleClick, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const targetId = this.dataset.targetId;
    this.navItems.forEach((navItem) => {
      const isActive = navItem.dataset.targetId === targetId;
      navItem.classList.toggle(TabsCustom.activeClass, isActive);
    });

    this.bodies.forEach((body) => {
      const isActive = body.dataset.targetId === targetId;
      body.classList.toggle(TabsCustom.activeClass, isActive);
    });
  };
}

if (!customElements.get("tabs-nav-item")) {
  customElements.define("tabs-nav-item", TabsCustom);
}
